import Vue from "vue";
import VueI18n from "vue-i18n";
const DEFAULT_LOCALE = "English";
import lang from "@/mapping/lang";
// import { logWithPrefix } from "@/plugins/logging";
// const log = logWithPrefix("[plugin/i18n.js]");

Vue.use(VueI18n);
const list = lang.lang;
const languageList = list
  .filter((o) => {
    return o.config !== "auto";
  })
  .map((o) => o.config);
const generateMessages = () => {
  let result = {};
  languageList.forEach((o) => {
    if (o != DEFAULT_LOCALE) {
      result[o] = Object.assign(
        {},
        require("@/locales/untranslate.json"),
        require("@/locales/wizard/" + DEFAULT_LOCALE + ".json"),
        require("@/locales/" + DEFAULT_LOCALE + ".json"),
      );
      try {
        result[o] = Object.assign(result[o], require("@/locales/wizard/" + o + ".json"));
      } catch {
        // console.log("Failed to load wizard/" + o + ".json");
      }
      try {
        result[o] = Object.assign(result[o], require("@/locales/" + o + ".json"));
      } catch {
        // log("Failed to load " + o + ".json");
      }
    } else {
      result[o] = Object.assign(
        {},
        require("@/locales/untranslate.json"),
        require("@/locales/wizard/" + o + ".json"),
        require("@/locales/" + o + ".json"),
      );
    }
  });
  return result;
};

const i18n = new VueI18n({
  locale: localStorage.getItem("locale"),
  fallbackLocale: DEFAULT_LOCALE, // 匹配不到locale时的默认语言
  silentTranslationWarn: true,
  messages: generateMessages(),
});

export default i18n;
